import React from 'react'
import { graphql } from 'gatsby'
import BlogTemplate from 'src/components/templates/blog-template.js'

const title = '導入事例'
const description =
  'commmune(コミューン)をご利用するお客様の事例紹介ページです。BtoB、BtoC問わず様々なお客様のオンライン顧客接点・ユーザーコミュニティを通じたコミュニティマーケティングの事例をご紹介します。'

const pageTitle = '導入事例'
const pageHeading = 'CASE'

const Case = ({ data: { allMarkdownRemark }, location }) => {
  return (
    <BlogTemplate
      title={title}
      description={description}
      pageTitle={pageTitle}
      pageHeading={pageHeading}
      allMarkdownRemark={allMarkdownRemark}
      location={location}
    />
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/case/" } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      totalCount
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
      edges {
        node {
          id
          frontmatter {
            title
            tags
            thumbnail {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
            slug
          }
          excerpt(truncate: true)
        }
      }
    }
  }
`

export default Case
